import { FilterState } from '@/components/FilterManager/types';
import { EntityTagInput } from '@/types/schema';

import NewTagFilter from './TagFilter';
import { useTagStateAndMethods } from './useTagStateAndMethods';

export const isTagPillSelected = (filter: FilterState, id: string) => {
  const selectedItems = filter['tagFilters'] as EntityTagInput[] | undefined;

  return (
    Array.isArray(selectedItems) &&
    selectedItems.length > 0 &&
    selectedItems.some((item) => item.tagId === id)
  );
};
export const isFeaturedTagPillSelected = (filter: FilterState, id: string) => {
  const selectedItems = filter['featuredTagFilters'] as EntityTagInput[] | undefined;

  return (
    Array.isArray(selectedItems) &&
    selectedItems.length > 0 &&
    selectedItems.some((item) => item.tagId === id)
  );
};
const TagsPills = ({
  filter,
  setFilter,
  id,
  ...rest
}: {
  filter: FilterState;
  setFilter: (filter: any) => void;
  id: string;
  filterIdToOpen?: string;
  setFilterIdToOpen: (id: string) => void;
  isNonEditableIds?: string[];
}) => {
  const {
    methods,
    state: { selectedFilters },
  } = useTagStateAndMethods({
    filter,
    setFilter,
    id,
  });

  const isSelectedFiltersAnArray = Array.isArray(selectedFilters);
  if (!isSelectedFiltersAnArray || selectedFilters.length === 0) return null;

  return (
    <>
      {selectedFilters?.map((tag) => {
        return <NewTagFilter key={tag.tagId} {...methods} tagFilterType={tag} {...rest} />;
      })}
    </>
  );
};

export default TagsPills;
